/**
 * KAN-950: videos of the current cabinet section inside the tutorial modal.
 * The playing one is marked; a click switches the video in the same modal.
 */
import { PlayCircle } from 'lucide-react';
import { cn } from '@/lib/utils';
import { formatDuration } from '@/tutorials/content';
import type { SectionVideo } from '@/tutorials/sections';

interface TutorialSectionListProps {
  videos: SectionVideo[];
  currentSlug: string;
  onSelect: (slug: string) => void;
}

export function TutorialSectionList({ videos, currentSlug, onSelect }: TutorialSectionListProps) {
  return (
    <nav aria-label="Ролики раздела">
      <ul className="space-y-1">
        {videos.map((video) => {
          const active = video.slug === currentSlug;
          return (
            <li key={video.slug}>
              <button
                type="button"
                onClick={() => onSelect(video.slug)}
                aria-current={active ? 'true' : undefined}
                className={cn(
                  'flex w-full items-center gap-3 rounded-md px-3 py-2 text-left text-sm transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500',
                  active
                    ? 'bg-blue-50 font-medium text-blue-700'
                    : 'text-gray-700 hover:bg-gray-100 hover:text-gray-900'
                )}
              >
                <PlayCircle
                  aria-hidden="true"
                  className={cn('h-4 w-4 shrink-0', active ? 'text-blue-600' : 'text-gray-400')}
                />
                <span className="min-w-0 flex-1">{video.title}</span>
                {video.duration !== undefined && (
                  <span className="shrink-0 tabular-nums text-xs text-gray-500">
                    {formatDuration(video.duration)}
                  </span>
                )}
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
